import { queryOptions } from '@tanstack/react-query';
import { API_URL } from '@shared/services/api.config';
import { linkRegistry } from '@shared/services/hateoas/linkRegistry';
import { SessionExpiredError } from '@shared/utils/SessionExpiredError';
import { queryClient } from './client';

export interface AccountBody {
  data?: Record<string, unknown>;
  _links?: Record<string, { href: string; type?: string; templated?: boolean }>;
}

const fetchAccount = async (): Promise<AccountBody> => {
  const response = await fetch(`${API_URL}/api/account/me`, {
    method: 'GET',
    credentials: 'include',
  });

  if (response.status === 401 || response.status === 403) {
    throw new SessionExpiredError();
  }

  if (!response.ok) {
    throw new Error('Failed to initialize HATEOAS');
  }

  const body: AccountBody = await response.json();
  if (body._links) linkRegistry.merge('root', body._links);
  return body;
};

export const accountQuery = queryOptions({
  queryKey: ['account', 'me'] as const,
  queryFn: fetchAccount,
  staleTime: Infinity,
  gcTime: Infinity,
});

export const ensureAccount = (): Promise<AccountBody> => queryClient.ensureQueryData(accountQuery);
